/* Startseite (Startseite-Design-Runde2-1011 Teil 3.1 „Bewegung“): Module erscheinen einmal beim Scrollen (opacity 0 → 1,
   translateY 12 → 0, 400 ms, ab 15 % sichtbar), nur unterhalb des ersten Bildschirms, nie bei prefers-reduced-motion.
   Reiter der Produktreihe: Tastatur (Pfeile), Überblendung 150 ms, „Alle ansehen →“ im Kopf folgt dem Reiter. */
(function () {
  if (window.__rdStart) return;
  window.__rdStart = true;

  function einblenden() {
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (still || !('IntersectionObserver' in window)) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-rd-reveal]'));
    var h = window.innerHeight || 800;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-sichtbar');
        io.unobserve(e.target);
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < h * 0.9) return;
      el.classList.add('is-wartet');
      io.observe(el);
    });
  }

  function reiter(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var alle = root.querySelector('[data-rd-alle]');
    function zeige(t) {
      tabs.forEach(function (x) {
        var an = x === t;
        x.setAttribute('aria-selected', an ? 'true' : 'false');
        x.tabIndex = an ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (!p) return;
        p.hidden = !an;
        if (an) { p.classList.remove('is-neu'); void p.offsetWidth; p.classList.add('is-neu'); }
      });
      if (alle && t.dataset.alleUrl) { alle.href = t.dataset.alleUrl; alle.setAttribute('aria-label', t.dataset.alleText || ''); }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { zeige(t); });
      t.addEventListener('keydown', function (e) {
        var j = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
        if (j === null) return;
        e.preventDefault();
        j = (j + tabs.length) % tabs.length;
        tabs[j].focus();
        zeige(tabs[j]);
      });
    });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rd-reiter]'), reiter);
    einblenden();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
